<app-creditor-cases-list-filters (filtersReady)="handleFiltersState($event)" (submitFilters)="handleFilters($event)"
                                 (parentFilter)="applyFilters()" (parentNewCase)="newCasePrefill()"
                                 (parentClearFilters)="clearFilters()"
                                 [onlyRelated]="onlyRelated">
</app-creditor-cases-list-filters>

<!--If all are selected and there is more to select on another page -->
<div *ngIf="filtersReady && caseCreditorListFilter && pageSelected && (totalPages > 1)" class="row mb-3">
  <div class="col-12">
    <div class="global-select-all">
      <p class="m-0" *ngIf="!caseCreditorListFilter.select_all">
        Selected <b>{{ selection.selected.length }}</b> records on this page.
        <button mat-button color="primary" (click)="globalSelectAll($event)">
          Select all {{ totalResults | number }} records
        </button>
      </p>
      <p class="m-0" *ngIf="caseCreditorListFilter.select_all">
        All <b>{{ totalResults | number }}</b> records selected.
        <button mat-button color="primary" (click)="globalClearSelectAll($event)">Clear selection</button>
      </p>
    </div>
  </div>
</div>

<div class="row mt-4">
  <div class="col-12">
    <div class="mat-elevation-z8">
      <table mat-table matSort (matSortChange)="sortData($event)" [dataSource]="dataSource" width="100%">
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        <!-- Selection -->
        <ng-container matColumnDef="select">
          <!-- Select All On Page -->
          <th mat-header-cell *matHeaderCellDef>
            <mat-checkbox color="primary" (change)="$event ? togglePageSelect($event) : null"
                          [checked]="selection.hasValue() && allRowsSelected()"
                          [indeterminate]="selection.hasValue() && !allRowsSelected()">
            </mat-checkbox>
          </th>
          <!-- Select Row -->
          <td mat-cell *matCellDef="let row">
            <mat-checkbox (click)="$event.stopPropagation()" color="primary" [checked]="selection.isSelected(row)"
                          (change)="toggleRow($event, row)">
            </mat-checkbox>
          </td>
        </ng-container>
        <!-- Ref Number -->
        <ng-container matColumnDef="reference_number">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>{{ "CASES.model.ref_number" | translate }}</th>
          <td mat-cell *matCellDef="let element">
            <a class="pr-3" (click)="$event.stopPropagation()" [routerLink]="['/cases', element.case.id, 'creditors', element.id, 'general']">
              {{ element.reference_number }}</a></td>
        </ng-container>
        <!-- Product type -->
        <ng-container matColumnDef="product">
          <th mat-header-cell *matHeaderCellDef
              class="p-r-10">{{ "ADDRESS-BOOK.product_type" | translate }}
          </th>
          <td mat-cell *matCellDef="let element;">
            {{ element.product?.name }}
          </td>
        </ng-container>
        <!-- Creditor name -->
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>{{ "CASES.single.creditor-name" | translate }}</th>
          <td mat-cell *matCellDef="let element">
            {{element.creditor?.name}}
          </td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>
        <!-- Case Creditor Status -->
        <ng-container matColumnDef="case_creditor_status">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>
            {{ 'CONFIG.drip-campaign.list.table-data.statusable_type.case_creditor_status' | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            <span class="badge badge-info">{{ element.case_creditor_status?.name_es ? element.case_creditor_status?.name_es : 'N/A' }}</span>
          </td>
        </ng-container>
        <!-- Payment Status -->
        <ng-container matColumnDef="payment_status">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>
            {{ 'CASES.single.general.status_editor.payment_status' | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            <div>
              <span
                class="badge badge-info">{{ element?.case?.payment_status?.name ? element?.case?.payment_status?.name : 'N/A' }}</span>
            </div>
          </td>
        </ng-container>
        <!-- Case Status -->
        <ng-container matColumnDef="case_status">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>{{ "CASES.case-status" | translate }}</th>
          <td mat-cell *matCellDef="let element">
            <div>
              <span class="badge badge-primary">{{ element.case?.status?.name ? element.case?.status?.name : 'N/A' }}</span>
            </div>
          </td>
        </ng-container>
        <!-- Creditor type -->
        <ng-container matColumnDef="creditor_type">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>{{ 'CREDITORS.creditor-type' | translate }}</th>
          <td mat-cell *matCellDef="let element">
            {{ 'CASE_CREDITOR.model.creditor_type_options.' + element.creditor?.lender_type | translate}}
          </td>
        </ng-container>
        <!-- Original debt -->
        <ng-container matColumnDef="original_debt">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>
            {{'CASES.original_debt' | translate}}
          </th>
          <td mat-cell *matCellDef="let element">
            {{element.initial_balance | currency:'EUR'}}
          </td>
        </ng-container>
        <!-- Discount -->
        <ng-container matColumnDef="discount">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>
            {{'CASES.discount' | translate}} %
          </th>
          <td mat-cell *matCellDef="let element; let i = index">
            <span *ngIf="(element.initial_balance > 0) && (element.negotiated_amount > 0)">{{
                +(+(+(element.initial_balance - element.negotiated_amount) / element.initial_balance) *
                  100) | number: '1.2-2'
              }} <span *ngIf="(element.initial_balance > 0) && (element.negotiated_amount > 0)">%</span></span>
          </td>
        </ng-container>
        <!-- Current balance -->
        <ng-container matColumnDef="current_balance">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>
            {{'CASE_CREDITOR.model.current_balance' | translate}}
          </th>
          <td mat-cell *matCellDef="let element">
            {{(element.negotiated_amount || element.debt_amount || 0) | currency: 'EUR'}}
          </td>
        </ng-container>
        <!-- Available funds -->
        <ng-container matColumnDef="settlement_balance">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>
            {{'CASES.settlement_balance' | translate}}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ (element.case?.settlement_balance || 0) | currency:'EUR' }}
          </td>
        </ng-container>
        <!-- Can settle -->
        <ng-container matColumnDef="can_settle">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>
            {{ 'CASES.can_settle' | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ (element.can_settle ? "SHARED.yes" : "SHARED.no") | translate }}
          </td>
        </ng-container>

        <!-- Amount of creditors -->
        <ng-container matColumnDef="no_of_creditors">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>{{ 'DASHBOARD.number-of-creditors' | translate }}</th>
          <td mat-cell *matCellDef="let element">
            {{ element.case?.unsecured_case_creditors_count ? element.case?.unsecured_case_creditors_count : 'N/A' }}
          </td>
        </ng-container>
        <!-- Days in Status -->
        <ng-container matColumnDef="days_in_status">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>{{ 'CASES.days_in_status' | translate }}</th>
          <td mat-cell *matCellDef="let element">
            <div>
              <p class="m-0">{{ element.latest_case_creditor_status_log?.created_at | dateDifference }}</p>
            </div>
          </td>
        </ng-container>
        <!-- Amount Paid -->
        <ng-container matColumnDef="amount_paid">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>{{ "CASES.amount_paid" | translate }}</th>
          <td mat-cell *matCellDef="let element" class="pr-2">
            {{ element.case?.amount_paid ? (+element.case?.amount_paid | currency: "EUR") : 'N/A' }}
          </td>
        </ng-container>
        <!--Actions-->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>{{ "SHARED.actions" | translate }}</th>
          <td mat-cell *matCellDef="let element; let i = index">
            <button mat-icon-button class="ml-1" [matMenuTriggerFor]="menu" style="color: 0a2540;"
                    [disabled]="!isElementRestricted(element.case)">
              <mat-icon class="pr-1" style=" vertical-align: baseline !important; color: 0a2540;">
                settings
              </mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item
                      [disabled]="!canSendExtrajudicial.includes(authUser.id)"
                      (click)="sendExtrajudicialClaim(selection, element.case)">
                {{ 'SHARED.send' | translate }} {{ 'CASES.single.creditors.actions.extrajudicial_claim' | translate }}
              </button>
              <button mat-menu-item
                      (click)="changeStatus($event, selection, 'unsecured_creditors', element)">
                {{ 'CASES.list.bulk_actions.change_creditor_status_product' | translate }}
              </button>
              <button mat-menu-item *ngIf="element.case_reditor_status?.slug !== 'ds_settlement_requested'"
                      [disabled]="element.case_reditor_status?.slug === 'ds_settled'"
                      (click)="requestDebtSettlement(element, element.case)">
                {{ "CREDITORS.debt-settlement-request.title" | translate }}
              </button>
              <button mat-menu-item *ngIf="element.case_reditor_status?.slug === 'ds_settlement_requested'"
                      (click)="requestDebtSettlement(element, element.case)">
                View Debt Settlement Request
              </button>
              <button mat-menu-item
                      (click)="openPaymentPlanGenerationModal(element, element.case)">
                {{ "CASES.single.payments.actions.create_additional_payment_plan" | translate }}
              </button>
              <!--<button *ngIf="!element.verified" mat-menu-item [disabled]="element.case.contracts?.length === 0"-->
              <!--        (click)="verifyCreditor($event, [element.id], 'unsecured_creditors', element.case)">-->
              <!--  {{ "CASES.details.verify-send-mandates" | translate }}-->
              <!--</button>-->
              <!--<button *ngIf="element.verified" mat-menu-item-->
              <!--        (click)="verifyCreditor($event, [element.id], 'unsecured_creditors', element.case)">-->
              <!--  {{ "CASES.details.resend-mandates" | translate }}-->
              <!--</button>-->
              <button *ngIf="element.recovery_creditor_id" mat-menu-item
                      (click)="sendMandatesRecoveryAgent($event, [element.id])">
                {{ "CASES.details.send-mandates-recovery" | translate }}
              </button>
              <button mat-menu-item
                      (click)="sendProposalAndAccord([element.id], null, element.case)">
                {{ "CASES.details.send-proposal-accord" | translate }}
              </button>
            </mat-menu>
            <!-- <button mat-icon-button class="ml-21 edit-button" [id]="i" (click)="toggleLoanEditMode(i, element)"
                    style="color: 0a2540;" [disabled]="!isElementRestricted()">
              <mat-icon class="pr-1" style=" vertical-align: baseline !important; color: 0a2540;">
                {{ !isEditing || currentRow != i ? 'edit' : 'save' }}
              </mat-icon>
            </button> -->
            <mat-icon class="pr-1" style="color: #0a2540;" (click)="creditorDetails(element, $event)">info</mat-icon>
            <mat-icon class="ml-2" style="color: #0a2540;" (click)="openCalculationModal(element, $event)">euro_symbol
            </mat-icon>
          </td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>
      </table>
      <!-- Pagination -->
      <mat-paginator [length]="paginatorConfig.length" [pageSize]="paginatorConfig.pageSize" showFirstLastButtons
                     [pageSizeOptions]="[5, 10, 20, 50, 100]" (page)="paginatorChange($event)">
      </mat-paginator>
    </div>
  </div>
  <!-- Footer Actions -->
  <div class="my-2 col-12"
       *ngIf="authUser.role_id === 1 || authUser.role_id === 5 || authUser.role_id === 7
      || authUser.id === 678731 || authUser.id === 2597 || authUser.id === 704999">
    <!-- Export-->
    <button
      *ngIf="authUser.role_id === 1 || authUser.role_id === 2 || authUser.role_id === 5 || authUser.role_id === 7"
      mat-raised-button color="primary" [disabled]="selection.selected.length === 0"
      (click)="exportRecords(caseCreditorListFilter)" class="mr-3">
      {{ "CASES.list.export.button-name" | translate }}
    </button>
    <button matButton  mat-raised-button color="primary" [matMenuTriggerFor]="menu"> {{ "SHARED.bulk-actions" | translate }}</button>
    <mat-menu #menu="matMenu">
      <!-- Send extrajudicial claims -->
      <button mat-menu-item *ngIf="allowedUsers.includes(authUser.id)"  (click)="sendExtrajudicialClaims(caseCreditorListFilter)" class="mr-3">
        {{ "CASES.single.creditors.actions.extrajudicial_claim" | translate }}
      </button>
    </mat-menu>

  </div>
</div>
